@if (!loading) {
  <div class="pre-landing">
    <div style="text-align: center; margin-top: 20px">
      <h2>{{ "not_allowed.title" | translate }}</h2>
      <p>{{ "not_allowed.message" | translate }}</p>
    </div>
  </div>
}
